"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 71: Codemasters / Camerica (BF9093, BF9096, BF9097)
 * ------------------------------------------------------------------ *
 * The Fantastic Adventures of Dizzy, Fire Hawk, Bee 52, MiG 29 and the
 * other Camerica carts. The board is an UNROM clone:
 *
 *   $8000-$BFFF  16 KB switchable PRG window
 *   $C000-$FFFF  16 KB fixed to the last bank (the reset vector lives here)
 *   CHR          8 KB RAM, not banked
 *
 * The bank register is decoded from the ROM window: a write anywhere in
 * $8000-$FFFF stores its low four bits as the $8000 bank. The address bus
 * does not choose a register, only the data does. Dizzy's startup code is a
 * good example -- it writes $FFF0 and $FFF1 with the bank number, then jumps
 * into the window it just selected.
 *
 * Fire Hawk puts a one-screen mirroring register at $9000-$9FFF: bit 4
 * selects the page. No other game writes there, so the register is decoded
 * unconditionally. Every other write, including $8000-$8FFF and
 * $A000-$BFFF, is a bank select; that is what FCEUX does and what keeps the
 * Micro Machines / Ultimate Stuntman startup writes harmless.
 *
 * The old implementation here treated $8000-$BFFF and $C000-$FFFF as two
 * independent switchable windows and put a CHR bank at $F100. That is not
 * this board: it moved the fixed last bank out of $C000 and left Dizzy's
 * reset code pointing into an arbitrary bank, so the game sat on a blank
 * screen. The layout above is the one the wiki, FCEUX and the carts use.
 * ------------------------------------------------------------------ */

function register(Mappers) {
  Mappers[71] = function (nes) {
    this.nes = nes;
  };

  Mappers[71].prototype = new Mappers[0]();

  Mappers[71].prototype.reset = function () {
    Mappers[0].prototype.reset.apply(this);
    this.prgBank = 0;
    // null means "whatever the header's solder pads say". NES.loadROM()
    // applies that after loadROM(), so the mapper does not touch it.
    this.mirroringMode = null;
  };

  Mappers[71].prototype.write = function (address, value) {
    if (address < 0x8000) {
      Mappers[0].prototype.write.apply(this, arguments);
      return;
    }

    // Fire Hawk's one-screen mirroring register.
    if ((address & 0xf000) === 0x9000) {
      this.mirroringMode = (value & 0x10) !== 0 ? 1 : 0;
      this.applyMirroring();
      return;
    }

    // All remaining ROM writes are the PRG bank register. The address does
    // not matter: $FFF0, $FFF1 and $C000 all do the same thing.
    this.prgBank = value & 0x0f;
    this.loadRomBank(this.prgBank, 0x8000);
  };

  Mappers[71].prototype.applyMirroring = function () {
    if (this.mirroringMode === null) {
      return;
    }
    this.setMirroring(
      this.mirroringMode
        ? this.nes.ppu.MIRRORING_TYPES.SINGLE_SCREEN_ALT
        : this.nes.ppu.MIRRORING_TYPES.SINGLE_SCREEN,
    );
  };

  Mappers[71].prototype.updatePrgBanks = function () {
    var rom = this.nes.rom;
    if (!rom || rom.romCount === 0) {
      return;
    }
    this.loadRomBank(this.prgBank, 0x8000);
    this.loadRomBank(rom.romCount - 1, 0xc000);
  };

  Mappers[71].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("Codemasters: Invalid ROM! Unable to load.");
    }

    this.reset();
    this.loadCHRROM();
    this.loadBatteryRam();
    this.loadTrainer();
    this.updatePrgBanks();
    this.resetIrqHandler();
  };

  Mappers[71].prototype.toJSON = function () {
    var s = Mappers[0].prototype.toJSON.apply(this);
    s.prgBank = this.prgBank;
    s.mirroringMode = this.mirroringMode;
    return s;
  };

  Mappers[71].prototype.fromJSON = function (s) {
    Mappers[0].prototype.fromJSON.apply(this, arguments);
    this.prgBank = s.prgBank;
    this.mirroringMode = s.mirroringMode;
    this.updatePrgBanks();
    this.applyMirroring();
  };
}

module.exports = { register: register };
